import { Component, OnInit, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { UserSessionService } from 'src/app/services/usersession.service';
import swal from 'sweetalert2';
import * as _ from 'lodash';
import { TranslateService } from '@ngx-translate/core';

import { NavigationService } from 'src/app/services/navigation.service';
import { MatDialog } from '@angular/material/dialog';
import { ChangepasswordComponent } from '../changepassword/changepassword.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { RoleType } from 'src/enum/roletype';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { RegionService } from 'src/app/services/region.service';
import { Router, RouterLink } from '@angular/router';
import { $ } from 'protractor';
@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
  form: FormGroup;
  username: '';
  clientList: any[];
  client = [];
  languageType: any;
  Languages: any[];
  dropdownconfig = {};
  // tslint:disable-next-line: variable-name
  user_url: string;
  userdata: any;
  userImg: any;
  userId: number;
  emailId: any;
  roleName: any;
  roleId: number;
  subDetail: any;
  pageType: any;
  profiledetail: any[];
  public RoleEnumType = RoleType;
  binaryFile: any;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    public translate: TranslateService,
    private userSessionService: UserSessionService,
    private authService: AuthenticationService,
    private navigationService: NavigationService,
    private router: Router,
    public dialog: MatDialog,
    private formBuilder: FormBuilder,
    private regionService: RegionService,
  ) {
    // this.userId = this.userSessionService.userId();
    // this.emailId = this.userSessionService.getEmail();
    // this.roleId = this.userSessionService.roleId();
  }

  ngOnInit(): void {
    this.username = this.userSessionService.getUserName();
    this.roleName = this.userSessionService.roleName();
    this.roleId = this.userSessionService.roleId();
    this.emailId = this.userSessionService.subUserApplicant();
    this.initializeValidators();
    this.getProfile();
    // this.regionService.getFile(24).subscribe(response => {
    //   this.binaryFile = response.value.binary;
    //   //this.binaryFile = 'data:image/'+response.value.filetype+';base64,' + (this.sanitizer.bypassSecurityTrustResourceUrl(response.value.binary) as any).changingThisBreaksApplicationSecurity;
    // });
  }

  refresh() {
  }


  initializeValidators() {
    this.form = this.formBuilder.group({
    });
  }

  getProfile() {
    if(Math.floor(this.roleId) == 9){
      this.roleId = 9;
    }
    if (this.roleId > 10) {
      this.pageType = 2;
    } else if (this.roleId != 9) {
      this.pageType = 1;
    }
    if (this.pageType) {
      this.regionService.getProfile(this.pageType).subscribe(res => {
        if (res && res.isSuccess) {
          this.profiledetail = res.value.Data[0];
          if(this.profiledetail['org_type']){
            this.subDetail = this.profiledetail['org_type'];
          }
          else if (this.pageType == 2) {
            this.subDetail = this.profiledetail['designation'];
          }
          else {
            this.subDetail = this.profiledetail['state'] + " - " + this.profiledetail['districtname'];
          }
        }
      });
    }
  }

  /**
   * Sidebar toggle on hamburger button click
   */
  toggleSidebar(e) {
    e.preventDefault();
    this.document.body.classList.toggle('sidebar-open');
  }

  gotoProfile() {
    var elems = document.querySelectorAll(".dropdown-menu.show");
    [].forEach.call(elems, function (el) {
      el.classList.remove("show");
    });
    this.router.navigate(["/profile"]);
  }
  /**
   * Logout
   */
  onLogout(e) {
    e.preventDefault();
    const title = this.translate.instant('Logout Confirmation');
    const txt = this.translate.instant('You want to logout');
    const Yes = this.translate.instant('Yes');
    const No = this.translate.instant('No');
    swal.fire({
      title,
      text: txt,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: Yes,
      cancelButtonText: No,
    }).then((result) => {
      if (result.value) {
        this.authService.logOut();
        // this.navigationService.goToLogin();
      }
    })
  }

  openMyProfile() {
    const myuserId = this.userSessionService.userId();
    this.user_url = '/user/' + myuserId;
  }

  openChangePasswordDialog() {
    const dialogRef = this.dialog.open(ChangepasswordComponent, {
      autoFocus: false,
      disableClose: true,
      panelClass: 'mat-dialog'
    })
    dialogRef.afterClosed().subscribe(data => {
      if (data) {
      }
    });
  }
}
